import octoCat from '../../assets/icon/Octocat.png';
import gitHubLogo from '../../assets/icon/GitHub_Logo.png';
import './footer.style.scss';

export const footer = `<div class="footer__git footer-icon">
<a href="https://github.com/llama-with-thumbs/covid-console/tree/covid-console#readme">
  <img src="${octoCat}" alt="github-llama-with-thumbs" title="app's repo">
</a>
<a href="https://github.com/llama-with-thumbs/covid-console/tree/covid-console#readme">
  <img src="${gitHubLogo}" alt="github-llama-with-thumbs" title="app's repo">
</a>
</div>`;
